import { borderRadius, height } from 'styled-system';
import { Image } from 'rebass/styled-components';
import styled from 'styled-components';
export default styled(Image).withConfig({
  displayName: "image",
  componentId: "sc-12rk19g-0"
})(["", " ", " &.--is-link{cursor:pointer;}"], borderRadius, height);